import {createContext, useContext} from 'react';

import {useResponsive} from '@/hooks/useResponsive';

const ResponsiveContext = createContext<ReturnType<typeof useResponsive> | null>(null);

export const ResponsiveProvider = ({children}: {children: React.ReactNode}) => {
  const responsive = useResponsive();

  return <ResponsiveContext.Provider value={responsive}>{children}</ResponsiveContext.Provider>;
};

export const useResponsiveContext = () => {
  const context = useContext(ResponsiveContext);
  if (!context) {
    throw new Error('useResponsiveContext must be used within a <ResponsiveProvider>');
  }
  return context;
};
